var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-button',{staticClass:"mr-0",attrs:{"slot":"actions","icon":"fa fa-arrow-left","flat":"","color":"danger","title":_vm.$t('modal.back'),"id":"backBtn"},on:{"click":function($event){return _vm.Reload()}},slot:"actions"})}
var staticRenderFns = []

export { render, staticRenderFns }